import { z } from '../utils/zod.js';
import { dataResponse } from '../utils/response-templates.js';
import { planOverridesSchema } from '../pricing-catalogue.js';
import { createOrganizationRequestSchema } from '../organizations.js';
import { adminUserCompactSchema } from './compact.js';
import { adminPageResponse } from './pagination.js';
import { staffReasonSchema } from './staff.js';
export const adminReasonRequestSchema = z.object({
    reason: staffReasonSchema,
});
export const adminUpdateUserRequestSchema = z
    .object({
    name: z.string().trim().min(1).max(150).optional(),
    language: z.string().trim().min(2).max(20).optional(),
    reason: staffReasonSchema,
})
    .refine((body) => body.name !== undefined || body.language !== undefined, {
    message: 'Provide name and/or language',
    path: ['name'],
});
export const adminBillingExemptRequestSchema = z.object({
    exempt: z.boolean(),
    reason: staffReasonSchema,
});
export const adminPlanOverridesRequestSchema = z.object({
    planOverrides: planOverridesSchema.nullable().openapi({ description: 'null removes every override' }),
    reason: staffReasonSchema,
});
export const adminMcpAccessRequestSchema = z.object({
    mcpAccessUntil: z
        .string()
        .datetime({ offset: true })
        .nullable()
        .openapi({ description: 'null falls back to the trial window' }),
    reason: staffReasonSchema,
});
export const adminMcpBlockRequestSchema = z.object({
    blockReason: z.string().trim().min(1).max(500),
    reason: staffReasonSchema,
});
export const adminUpdateOrganizationRequestSchema = createOrganizationRequestSchema
    .pick({ name: true, country: true, taxId: true })
    .partial()
    .extend({ name: z.string().trim().min(1).max(255).optional(), reason: staffReasonSchema })
    .refine((body) => body.name !== undefined || body.country !== undefined || body.taxId !== undefined, {
    message: 'Provide name, country and/or taxId',
    path: ['name'],
});
export const adminRemindSignerRequestSchema = z.object({
    signerId: z.string().uuid(),
    reason: staffReasonSchema,
});
export const adminInvitationIdParamsSchema = z.object({
    invitationId: z.string().uuid(),
});
export const ADMIN_INVITATION_STATUSES = ['INVITED', 'ACCEPTED', 'EXPIRED'];
export const adminInvitationDtoSchema = z.object({
    id: z.string().uuid(),
    createdAt: z.string().datetime(),
    email: z.string(),
    status: z.enum(ADMIN_INVITATION_STATUSES),
    expiresAt: z.string().datetime(),
    acceptedAt: z.string().datetime().nullable(),
    organizationId: z.string().uuid(),
    invitedBy: adminUserCompactSchema,
});
export const adminInvitationResponseSchema = dataResponse(adminInvitationDtoSchema);
export const adminListInvitationsResponseSchema = adminPageResponse(adminInvitationDtoSchema);
